<ng-container *ngIf="siteForm">
  <h4>How will CurbNTurfers access the site?</h4>
  <p>(Select all that apply)</p>
  <div class="button-wrapper-grid listing">
    <label class="cnt-button" [ngClass]="{ active: selected('pullThrough') }">
      <input type="radio" name="parkingAccess" value="pullThrough" (change)="select('pullThrough')" />
      <span class="cnt-button-icon">
        <curbnturf-site-svgs type="pullThrough" [white]="selected('pullThrough')"> </curbnturf-site-svgs>
      </span>
      <span class="cnt-button-copy">Pull Through</span>
    </label>
    <label class="cnt-button" [ngClass]="{ active: selected('backIn') }">
      <input type="radio" name="parkingAccess" value="backIn" (change)="select('backIn')" />
      <span class="cnt-button-icon">
        <curbnturf-site-svgs type="backIn" [white]="selected('backIn')"> </curbnturf-site-svgs>
      </span>
      <span class="cnt-button-copy">Back In/Out</span>
    </label>
  </div>
  <p *ngIf="parkingError && ParkingValidator(this.amenities)?.invalidParking" class="alert-danger">
    <i class="icon-cnt-times-circle"></i>
    {{ parkingError }}
  </p>
  <div *ngIf="editView && !selected('pullThrough') && !selected('backIn')">
    <div class="alert-danger">
      Please complete the &ldquo;How will CurbNTurfers access the site?&rdquo; section above.
    </div>
    <div class="_18-px-spacer"></div>
  </div>

  <div class="title-information-wrapper">
    <h4>What is the max RV size you can accept at the site?</h4>
  </div>
  <p>(Select all that apply)</p>
  <div class="input-wrapper">
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxLength"
        [formControl]="maxLength"
        [containerElement]="maxLengthError"
        type="number"
        min="0"
        class="text-field-rounded-left w-input"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxLength">Max length (FT)</label>
        </div>
      </div>
    </div>
    <div #maxLengthError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxWidth"
        [formControl]="maxWidth"
        [containerElement]="maxWidthError"
        type="number"
        min="0"
        class="text-field-rounded-left w-input"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxWidth">Max width (FT)</label>
        </div>
      </div>
    </div>
    <div #maxWidthError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
    <div class="input-w-label curbnturf-label-input-container">
      <input
        id="maxHeight"
        [formControl]="maxHeight"
        [containerElement]="maxHeightError"
        type="number"
        min="0"
        class="text-field-rounded-left w-input"
      />
      <div class="text-field-label">
        <div class="cnt-button-copy">
          <label for="maxHeight">Max height (FT)</label>
        </div>
      </div>
    </div>
    <div #maxHeightError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
  </div>
  <h4>How many people can the site accommodate?</h4>
  <div class="input-wrapper">
    <div class="cnt-input-wrapper">
      <input
        id="max-guests"
        type="number"
        min="1"
        [formControl]="maxGuests"
        [containerElement]="maxGuestsError"
        class="text-field-rounded w-input"
      />
      <div class="text-block-18">
        <label for="max-guests">Guests per site.</label>
      </div>
    </div>
    <p *ngIf="guestNumberError" class="alert-danger">
      <i class="icon-cnt-times-circle"></i>
      {{ guestNumberError }}
    </p>
    <div #maxGuestsError="curbnturfDisplayValidationErrorsContainerRef" curbnturfDisplayValidationErrorsContainer></div>
  </div>
  <curbnturf-wheelchair-input [amenities]="amenities"> </curbnturf-wheelchair-input>
</ng-container>
